import React from 'react'
import { useSelector } from 'react-redux'
import { OsBlockWarning } from './components'

export function OsBlockDrawer() {
  const { stage, data } = useSelector(({ drawer }) => drawer)

  return stages({ message: data.message })[stage]
}

function stages({ ...props }) {
  return {
    initial: <OsBlockWarning {...props} />,
  }
}
